// extracted by mini-css-extract-plugin
module.exports = {"main-slider":"DesktopHomeSlider_main-slider__gMjvN","thumbnails":"DesktopHomeSlider_thumbnails__u7mvN"};